import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { makeFichaAvisoURL, makeCompanyURL } from '@navent-jobs/interlinking'

// components
import CardPlaceholder from '../../../../components/card/CardPlaceholder'

// mixins
import {
  SponsorComponent,
  SponsorFooter,
  SponsorBody,
  CompanyWrapper,
  CompanyLogo,
  CompanyTitle,
  Strong,
  SponsorLink,
  ListadoAvisoCard,
} from './mixins'
import { IS_ZONA_JOBS } from '../../../../constants'

const CONFIDENCIAL = 'Confidencial'

interface Empresa {
  logo: string
  nombre: string
  id: number
}

interface Aviso {
  id?: number
  titulo?: string
  logoURL?: string
  empresa?: string
  localizacion?: string
  portal?: string
}
interface ListadoSponsorProps {
  activeAviso: {
    activeAvisoId: number
  }
  currentPage: number
  avisosSponsoreados: {
    empresa: Empresa
    avisos: Aviso[]
  }
  loading: boolean
  onClick: Function
}

const ListadoSponsor = ({ activeAviso, avisosSponsoreados, currentPage, loading, onClick }: ListadoSponsorProps) => {
  const [empresa, setEmpresa] = useState<Empresa>()
  const [avisos, setAvisos] = useState<Aviso[]>()

  useEffect(() => {
    if (avisosSponsoreados) {
      setEmpresa(avisosSponsoreados.empresa)
      setAvisos(avisosSponsoreados.avisos)
    }
  }, [avisosSponsoreados])

  if (loading) {
    return <CardPlaceholder />
  }

  return currentPage === 1 && empresa ? (
    <SponsorComponent>
      <SponsorBody>
        {avisos &&
          avisos.map((aviso, index) => {
            return (
              <ListadoAvisoCard
                key={aviso.id}
                aviso={aviso}
                index={index}
                disableLink={false}
                ubicacion="Listado sponsor"
                activeAvisoId={activeAviso && activeAviso.activeAvisoId}
                onClick={({ event }) =>
                  onClick(
                    event,
                    makeFichaAvisoURL({
                      ...aviso,
                      empresa: { denominacion: aviso.empresa, confidencial: aviso.empresa === CONFIDENCIAL },
                    }),
                    IS_ZONA_JOBS && aviso.portal?.toLowerCase() === 'bumeran'
                  )
                }
                link={makeFichaAvisoURL({
                  ...aviso,
                  empresa: { denominacion: aviso.empresa, confidencial: aviso.empresa === CONFIDENCIAL },
                })}
              />
            )
          })}
      </SponsorBody>

      <SponsorFooter>
        <CompanyWrapper>
          {empresa.logo && <CompanyLogo alt="logo_listado" src={empresa.logo} />}

          <CompanyTitle>
            Empleos en <Strong>{empresa.nombre}</Strong>
          </CompanyTitle>
        </CompanyWrapper>

        <SponsorLink
          href={makeCompanyURL({
            denominacion: empresa.nombre || CONFIDENCIAL,
            confidencial: empresa.nombre === CONFIDENCIAL,
            id: empresa.id,
          })}
          linkoptions={{
            native: false,
            type: 'outline',
          }}
          target="_blank"
        >
          Ver más
        </SponsorLink>
      </SponsorFooter>
    </SponsorComponent>
  ) : null
}

const states = ({ listadoAvisosStore, activeAvisoStore }) => ({
  loading: listadoAvisosStore.loading,
  activeAviso: activeAvisoStore,
  avisosSponsoreados: listadoAvisosStore.avisosSponsoreados,
  currentPage: listadoAvisosStore.pagination.currentPage,
})

export default connect(states)(ListadoSponsor)
